const show = ({ title = "", message = "", type = "success" } = {}) => {
  const container = document.querySelector(".app-main") || document.body

  const existingToast = container.querySelector(".toast-v2")
  if (existingToast) {
    existingToast.remove()
  }

  const icon =
    type === "error"
      ? `<svg class="toast-v2_icon ${type}" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="m15 9-6 6"/>
                    <path d="m9 9 6 6"/>
                   </svg>`
      : `<svg class="toast-v2_icon ${type}" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6 9 17l-5-5"/>
                   </svg>`

  const animatedIcon =
    type === "error"
      ? `<div class="error-animated">
                    <svg class="circle-border" viewBox="0 0 35 35">
                        <circle cx="17.5" cy="17.5" r="16"/>
                    </svg>
                    <svg class="cross" viewBox="0 0 35 35" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
                        <line class="cross-line" x1="11" y1="11" x2="24" y2="24"/>
                        <line class="cross-line" x1="24" y1="11" x2="11" y2="24"/>
                    </svg>
                   </div>`
      : `<div class="checkmark-animated">
                    <svg class="circle-border" viewBox="0 0 35 35">
                        <circle cx="17.5" cy="17.5" r="16"/>
                    </svg>
                    <svg class="checkmark" viewBox="0 0 18 18" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 18px; height: 18px;">
                        <path d="M 4 9 L 7.5 12.5 L 14 6"/>
                    </svg>
                   </div>`

  const defaultTitle = type === "error" ? "Ошибка" : "Успешно"
  const defaultMessage = type === "error" ? "Что-то пошло не так" : "Операция выполнена"

  const toastHTML = `
                <div class="toast-v2 ${type}">
                  <div class="toast-v2_content">
                    <div class="toast-v2_icon-wrapper ${type}">
                      ${icon}
                      ${animatedIcon}
                    </div>
                    <div class="toast-v2_message">
                      <span class="text-1">${title || defaultTitle}</span>
                      <span class="text-2">${message || defaultMessage}</span>
                    </div>
                  </div>
                  <svg class="toast-v2_close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
                  </svg>
                  <div class="toast-v2_progress"></div>
                </div>
            `

  container.insertAdjacentHTML("beforeend", toastHTML)

  const toast = container.querySelector(".toast-v2")
  const closeBtn = toast.querySelector(".toast-v2_close")
  const progress = toast.querySelector(".toast-v2_progress")

  let autoCloseTimer = null

  const startProgress = () => {
    if (progress) {
      progress.classList.remove("active")
      void progress.offsetWidth
      progress.classList.add("active")

      if (autoCloseTimer) {
        clearTimeout(autoCloseTimer)
      }

      autoCloseTimer = setTimeout(() => {
        toast.classList.remove("active")
        setTimeout(() => toast.remove(), 500)
      }, 4100)
    }
  }

  setTimeout(() => {
    toast.classList.add("active")
    startProgress()

    const animated = toast.querySelector(
      type === "error" ? ".error-animated" : ".checkmark-animated"
    )
    setTimeout(() => {
      animated.classList.add("animate")
    }, 100)
  }, 10)

  closeBtn.addEventListener("click", () => {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer)
    }

    toast.classList.remove("active")
    progress.classList.remove("active")
    setTimeout(() => toast.remove(), 500)
  })
}

export const Toast = {
  show,
}
